export enum ShippingStatus {
    Pending = 'pending',
    Invalid = 'invalid',
    Valid = 'valid',
    Canceled = 'canceled',
}
